import AsyncState, { createAsyncStateReducer } from "react-async-stateful";

import * as StorageUtils from "../../lib/util/StorageUtils";
import * as ReduxUtils from "../../lib/util/ReduxUtils";
import { OVERRIDE_PROGRAM_KEY } from "../../StorageKeys";

import * as ProgramActions from "./Program.action";

export interface ProgramReducerState {
	currentProgram: AsyncState<void>;
	programIdOverride: string | undefined;
}

const initialState: ProgramReducerState = {
	currentProgram: AsyncState.create(),
	programIdOverride: undefined,
};

export default ReduxUtils.composeReducer(
	initialState,
	(initialState) => ({
		...initialState,
		programIdOverride: StorageUtils.get(OVERRIDE_PROGRAM_KEY),
	}),
	[
		createAsyncStateReducer<ProgramReducerState>({
			currentProgram: ProgramActions.getProgramData.type,
		}),
		ReduxUtils.createReducerMap({
			[ProgramActions.setProgram.type]: (state, action) => ({
				...state,
				programIdOverride: action.payload,
			}),
		}),
	],
);
